module.exports = __webpack_public_path__ + "static/project-mockup-4cedd78db1108ba6fd577d17fe783f45.png";